import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";

export default function AdminTagsPage() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");

  const load = async () => { const { data } = await api.get("/admin/tags"); setItems(data || []); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name) return;
    await api.post("/admin/tags", { translations: { tr: { name }, en: { name: "" } } });
    setName(""); load();
  };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/admin/tags/${id}`); load(); };

  return (
    <div data-testid="admin-tags">
      <h1 className="font-serif text-4xl text-cc-text mb-2">Etiketler</h1>
      <p className="text-sm text-cc-muted mb-8">İçerikleri etiketle</p>

      <form onSubmit={add} className="bg-white border border-admin-border p-5 mb-8 flex gap-3 items-end">
        <label className="flex-1 text-xs text-cc-muted">Yeni etiket <input value={name} onChange={(e) => setName(e.target.value)} className="cc-input" placeholder="Örn: balon" /></label>
        <button className="cc-btn text-[10px] py-2"><Plus size={14} /> Ekle</button>
      </form>

      <div className="flex flex-wrap gap-2">
        {items.map((t) => (
          <span key={t.id} className="bg-white border border-admin-border px-3 py-1.5 text-xs flex items-center gap-2">
            {t.translations?.tr?.name}
            <button onClick={() => del(t.id)} className="text-cc-muted hover:text-red-600"><Trash2 size={12} /></button>
          </span>
        ))}
        {items.length === 0 && <p className="text-cc-muted text-sm">Henüz etiket yok.</p>}
      </div>
    </div>
  );
}
